import React, { useMemo } from "react";
import { Lock } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
import { cn } from "~/lib/cn";

export const PrivateIcon = React.memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const className = useMemo(
      () => cn("text-text-tertiary cursor-help", props.className),
      [props.className],
    );

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Lock {...props} className={className} />
        </TooltipTrigger>
        <TooltipContent>
          This information is private. It will not be shown publicly.
        </TooltipContent>
      </Tooltip>
    );
  },
);
